import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import { accountStore, userStore } from '@/services/auth/store';
import { session } from '@/services/session';
import { billing } from '@/services/billing';
import { writeUserDetailsCookie } from '@/services/auth/user-details-cookie';

// Writes the `_current_user_details` cookie the docs site reads for targeting.
// Ember wrote it from its `app` route, which never runs on Hydra-native pages;
// this shell is always mounted, so it covers every authenticated page and
// re-writes on account switch/masquerade and once the plan type resolves.
export function useUserDetailsCookie(): void {
  const isAuthenticated = useStore(session.isAuthenticated);
  const account = useStore(accountStore);
  const user = useStore(userStore);
  const planType = useStore(billing.planType);

  useEffect(() => {
    if (!isAuthenticated || account == null || user == null) {
      return;
    }

    writeUserDetailsCookie({ user, account, planType });
  }, [isAuthenticated, account, user, planType]);
}
